import { NavigationMode } from '@app/common/navigation-mode.';
import { Environment } from '@environments/interface.environment';
import { NewsModeFeaturedNews, NewsModePersonalNews } from '@app/common/news-mode';
import { TrendingResult } from '@app/common/trending-result';
import { AuthorizationMode } from '@app/common/authorization-mode';
import { ManagedProperties } from '@app/common/managed-property-config';
import { DefaultProtectedResourceScopesMap } from '@app/common/msal-angular-configuration';
import { RssFeedAmount } from '@app/common/rss-feed';
import { FilterButtonInfo } from '@app/models/filter-button-info';

export const environment: Environment = {
  production: true,
  name: 'demo',
  tenantHostUrl: 'https://booldemo.sharepoint.com',
  coreWorkplaceSiteUrl: 'https://booldemo.sharepoint.com/sites/CoreIntranet',
  authorizationMode: AuthorizationMode.Claims,
  msalConfig: {
    tenant: 'booldemo.onmicrosoft.com',
    auth: {
      clientId: 'e5c3d455-d855-4d4b-9fc4-0c9ed821244c',
      authority: 'https://login.microsoftonline.com/booldemo.onmicrosoft.com',
    },
    domainHint: 'boolcloud.se',
    protectedResourceScopeMap: [
      ...DefaultProtectedResourceScopesMap,
      [`/api/`, [`e5c3d455-d855-4d4b-9fc4-0c9ed821244c/.default`]],
      ['https://booldemo.sharepoint.com', ['https://booldemo.sharepoint.com/.default']],
    ],
    useRedirect: true,
  },
  enableWorkplaceLight: true,
  featureSettings: {
    workplaceName: 'Contoso',
    appInsightsTrackingKey: '72c74fd6-d665-4ec4-8954-03fa2c44c9de',
    navigationMode: NavigationMode.HubSite,
    newsArchiveLink: 'https://booldemo.sharepoint.com/_layouts/15/sharepoint.aspx?v=news',
    sharePointNewsCenterUrl: 'https://booldemo.sharepoint.com/_layouts/15/sharepoint.aspx?v=news',
    newsCenterSiteUrl: 'https://booldemo.sharepoint.com/sites/Coremodern',
    newsModeFeaturedNews: NewsModeFeaturedNews.GraphFromNewsCenterSite,
    newsModePersonalNews: NewsModePersonalNews.GraphFromNewsCenterSite,
    managedPropertyConfig: ManagedProperties.DefaultConfig,
    trendingResult: TrendingResult.Modern,
    showNewOrModifiedbadgeOnAppTile: true,
    auditsEnabled: true,
    commentoScriptUrl: 'https://commento-corewp-01.azurewebsites.net/js/commento.js',
    bypassLicenseFilterInTopNav: false,
    enableAutoUserLanguageSync: true,
    enableLanguageFilteringForSharepointPages: true,
    enableLanguageFilteringForWorkplaceInfoboxes: true,
    enableLanguageFilteringForSharepointEvents: true,
    enableLanguageFilteringForWorkplace: true,
    showHubSiteFilterInSearch: true,
    hubSiteFilterInSearchDefault: false,
    enableNotificationSubscriptions: true,
    newsOrPageIconsInSearch : {
      news: {
        iconClass: '',
        iconUrl: 'https://booldemo.sharepoint.com/sites/CoreIntranet/SiteAssets/Image_News.png'
      },
      page: {
        iconClass: 'fa fa-book',
        iconUrl: ''
      }
    },
    enableTeamsNotification: true,
    enableProfileCardView: true,
    enableUserExperience: true,
    enableSearchFromCustomDB: true,
    enableProjectSection: true,
    rssFeedConfig: {
      feedLinksAndTagName: [
        {
          FeedLink: 'http://www.mynewsdesk.com/se/rss/source/307/pressrelease',
          TagName: 'BoolBySigma'
        }
      ],
      amountToShowPerLoad: RssFeedAmount.Medium
    },
    redirectToTeamsByDefault: true,
    enableRequiredReading: true,
    allowMarkAsReadFromReqReadList: true,
    prefixToO365Groups: 'Bool-',
    hotJarKey: '1502415',
    myColleagueRootTerm: 'fdc4ef06-e425-40ca-8483-57e0e7118a0f',
    enableRightSection: true,
    showBirthdayCalendar: true,
    showRestaurantMenus: true,

    enableIosA2hsBanner: true,
    showFilterByDepartmentButtons : true,
    newsFilterButtonConfig:
    [
      { Name: 'Hamburg', GUID: 'b92f5680-7b3c-4880-ad3f-ce9bfe9e363f', SortOrder: 1 } as FilterButtonInfo,
    ],
    disableLocalStorage: true,
    showPowerBIComponent: true,
    requireChannelSelectionForPowerBIVisuals: true,
    enableAzureADGroupSync: true,
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
